import React from 'react';
import { ShoppingCart } from 'lucide-react';
import { Order } from '../../types';

interface VisitOrdersSectionProps {
  orders: Order[];
  resolveProductName: (productId: string) => string;
}

const promotionLabel = (promo: string) => {
  if (promo === 'none') return 'Regular';
  if (promo === 'free_samples') return 'FREE SAMPLES';
  return promo.toUpperCase();
};

export const VisitOrdersSection: React.FC<VisitOrdersSectionProps> = ({
  orders,
  resolveProductName,
}) => {
  if (orders.length === 0) return null;

  return (
    <div className="bg-blue-50 p-4 rounded-xl border border-blue-200">
      <div className="flex items-center gap-2 mb-3">
        <ShoppingCart size={18} className="text-blue-600" />
        <h3 className="font-bold text-blue-900">Order lines ({orders.length})</h3>
      </div>
      <div className="space-y-2">
        {orders.map((order) => (
          <div key={order.id} className="bg-white p-4 rounded-lg border-2 border-blue-200">
            <div className="flex items-center justify-between">
              <div className="flex-1">
                <p className="font-bold text-gray-900">
                  {order.product_name || resolveProductName(order.product_id)}
                </p>
                {order.product_brand && (
                  <p className="text-xs text-gray-600">{order.product_brand}</p>
                )}
              </div>
              <div className="text-right ml-4">
                <p className="text-2xl font-black text-blue-600">{order.quantity}</p>
                <p className="text-xs text-gray-600 uppercase">Einheiten</p>
              </div>
            </div>
            <div className="mt-2 pt-2 border-t border-blue-100 flex flex-wrap gap-2">
              {order.distributor_name && (
                <span
                  className="inline-block px-3 py-1 bg-gray-100 text-gray-700 rounded-full
                    text-xs font-bold"
                >
                  {order.distributor_name}
                </span>
              )}
              {order.promotion_type && order.promotion_type !== 'none' && (
                <span
                  className="inline-block px-3 py-1 bg-orange-100 text-orange-700 rounded-full
                    text-xs font-bold"
                >
                  {promotionLabel(order.promotion_type)}
                </span>
              )}
            </div>
            {order.notes && (
              <div className="mt-2 pt-2 border-t border-blue-100">
                <p className="text-xs text-gray-700">{order.notes}</p>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
